import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left-x, delete, remove, backspace"} maskId="square-filled-radius-0-stroke-1-IconArrowLeftX"><path fillRule="evenodd" clipRule="evenodd" d="M7.48965 4L1.88965 12L7.48965 20H22V4H7.48965ZM10.9983 9.04289L13.25 11.2946L15.5016 9.04289L16.2087 9.75L13.9571 12.0017L16.2071 14.2517L15.5 14.9588L13.25 12.7088L11 14.9588L10.2929 14.2517L12.5429 12.0017L10.2912 9.75L10.9983 9.04289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeftX;
